import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { useAppStateContext } from 'src/AppState/AppState';
import { ButtonWrapper } from 'src/components/GlobalPageV2/QuestionFormV2/QuestionFormV2.style';
import { Input } from 'src/domains/common/components/input/input';
import { Button } from 'src/domains/common/components/button/button';
import { Textarea } from 'src/domains/layouts/shared/formComponents/textarea/Textarea';

export const PagesFormV2 = observer('PagesForm', () => {
    const { pagesStateV2 } = useAppStateContext();

    return (
        <>
            <h2 className='font-tertiary text-[1rem] font-semibold text-foreground leading-7 m-0 mb-1'>
                {pagesStateV2.isEditMode === true ? 'Edit question' : 'Create new'}
            </h2>

            <form
                className='gap-4 flex flex-col relative font-tertiary'
                onSubmit={(e) => e.preventDefault()}
            >
                {/* <Loader isActive={state.isLoading} /> */}

                {/* <LanguagesSelect
                    setAction={pagesStateV2.setLanguage}
                    value={pagesStateV2.language}
                    selectOptions={languageState.languages}
                /> */}

                <Input
                    label='Slug*'
                    placeholder='Placeholder'
                    formInputState={pagesStateV2.slug}
                    errors={pagesStateV2.slug.errorsForView}
                />
                <Input
                    label='Page Title*'
                    placeholder='Placeholder'
                    formInputState={pagesStateV2.title}
                    errors={pagesStateV2.title.errorsForView}
                />

                <label className='text-sm'>Content</label>
                <Textarea
                    // label='Content'
                    formState={pagesStateV2.content}
                    ckeditor
                    dataTest='add-page-content'
                />

                <Input
                    label='Description'
                    placeholder='Placeholder'
                    formInputState={pagesStateV2.page_description}
                    errors={pagesStateV2.page_description.errorsForView}
                />
                <Input
                    label='Keywords'
                    placeholder='Placeholder'
                    formInputState={pagesStateV2.keywords}
                    errors={pagesStateV2.keywords.errorsForView}
                />
                <Input
                    label='SEO title'
                    placeholder='Placeholder'
                    formInputState={pagesStateV2.seo_title}
                    errors={pagesStateV2.seo_title.errorsForView}
                />
                <ButtonWrapper>
                    <Button
                        className='mt-2 max-w-max'
                        variant='secondary'
                        onClick={() => pagesStateV2.handleCancel()}
                    >
                        Cancel
                    </Button>

                    <Button
                        className='mt-2 max-w-max'
                        variant='primary'
                        onClick={() => pagesStateV2.handleSubmit()}
                        disabled={pagesStateV2.isFormValid === false}
                    >
                        {pagesStateV2.isEditMode === true ? 'Update' : 'Create'}
                    </Button>
                </ButtonWrapper>
            </form>
        </>
    );
});
